export class LocalStorage {
    public get(key: string): any {
        return localStorage.getItem(key);
    }

    public set(key: string, value: string): void {
        localStorage.setItem(key, value);
    }
}
